import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { CreatorsSection } from './components/CreatorsSection';
import { CommunitySection } from './components/CommunitySection';
import { EventDetailsSection } from './components/EventDetailsSection';
import { TicketsSection } from './components/TicketsSection';
import { Footer } from './components/Footer';
import { ScrollProgress } from './components/ScrollProgress';
import { ImmersiveExperienceSection } from './components/ImmersiveExperienceSection';
import { InteractionSection } from './components/InteractionSection';
import { CulinarySection } from './components/CulinarySection';
import { CreditsSection } from './components/CreditsSection';
import { BringToYourCitySection } from './components/BringToYourCitySection';
import { HouseOfLionsSection } from './components/HouseOfLionsSection';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  useEffect(() => {
    // Add a class to the body for global styling
    document.body.classList.add('bg-black', 'text-white', 'overflow-x-hidden');
    // Cleanup function
    return () => {
      document.body.classList.remove('bg-black', 'text-white', 'overflow-x-hidden');
    };
  }, []);
  return <LanguageProvider data-id="element-0">
      <div className="relative" data-id="element-1">
        <ScrollProgress data-id="element-2" />
        <Navbar data-id="element-3" />
        <main className="w-full" data-id="element-4">
          <HeroSection data-id="element-5" />
          <AboutSection data-id="element-6" />
          <ImmersiveExperienceSection data-id="element-7" />
          <CulinarySection data-id="element-8" />
          <InteractionSection data-id="element-9" />
          <HouseOfLionsSection data-id="element-10" />
          <CreatorsSection data-id="element-11" />
          <CommunitySection data-id="element-12" />
          <EventDetailsSection data-id="element-13" />
          <TicketsSection data-id="element-14" />
          <BringToYourCitySection data-id="element-15" />
          <CreditsSection data-id="element-16" />
        </main>
        <Footer data-id="element-17" />
      </div>
    </LanguageProvider>;
}